import { render } from "./VNStockPopup.vue?vue&type=template&id=e4b24e0a&scoped=true"
import script from "./VNStockPopup.vue?vue&type=script&lang=js"
export * from "./VNStockPopup.vue?vue&type=script&lang=js"

import "./VNStockPopup.vue?vue&type=style&index=0&id=e4b24e0a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4b24e0a"]])

export default __exports__